module.exports = __webpack_public_path__ + "img/punch-out.020ff425.png";